module.exports = __webpack_public_path__ + "img/setinstall.61d1f73e.png";